import styles from "./styles.module.scss";
import StarIcon from "src/assets/icons/Star";

interface AspectImproveData {
  steps: string[];
  improvementValue: string;
  score: number;
}

interface AspectImproveProps {
  aspectImprove: AspectImproveData[];
  activeIndex: number;
}

export const AspectImprove = ({
  aspectImprove,
  activeIndex,
}: AspectImproveProps) => {
  const activeData = aspectImprove[activeIndex];

  if (!activeData) {
    return <div className={styles.empty}>No data available</div>;
  }

  return (
    <div className={styles.box}>
      <h2>Steps to improve review score</h2>
      {/* <div className={styles.predict}>
        <span className={styles.text}>
          Improving this aspect you will improve review score by {score}
        </span>
        <StarIcon />
        <span className={styles.value}>{improvementValue}</span>
      </div>
      <ul className={styles.list}>
        {steps.map((step) => (
          <li key={step}>{step}</li>
        ))}
      </ul> */}
    </div>
  );
};
